import { getAccess } from '../config/access';

/**
 * Access flags for the wind-down (KAT-230).
 *
 * Returns { login, restoreSession, product, checkout } — all true unless the
 * env config closes them. The value is frozen and stable across renders, so it
 * is safe to use directly in dependency arrays.
 */
export function useAccess() {
  return getAccess();
}
